

const achievements = [
  ["😱", "Extrovert", 0, 0],
  ["😐", "Vibe killer", 0, 1],
  ["😸", "Pussy expert", 0, 2],
  ["👯‍♀️", "Doppelgänger", 0, 3],
  ["🙅‍♂️", "Way off track", 0, 4],
  ["💦", "Impress professor", 0, 5],
  ["✍️", "Helper", 0, 6],
  ["🫰", "Real friend<small><small>|available on Patreon|</small></small>", 0, 7],
  ["🕵️", "Oops, Sherlock<small><small>|available on Patreon|</small></small>", 0, 8],
  ["🦪", "Accio clitoris<small><small>|available on Patreon|</small></small>", 0, 9],
  ["🍒", "Boob guy<small><small>|available on Patreon|</small></small>", 0, 10],
  ["🍑", "Butt guy<small><small>|available on Patreon|</small></small>", 0, 11],
  ["🗡️", "Sir Camelot<small><small>|available on Patreon|</small></small>", 0, 12],
  ["🤓", "Remaining knowledge<small><small>|available on Patreon|</small></small>", 0, 13],
  ["🏊", "The WETs<small><small>|available on Patreon|</small></small>", 0, 14],
  ["💤", "Wet dreams", 0, 15, 3],
];

export default achievements;
